import state from './Loading/states'
import mutations from './Loading/mutations'
import actions from './Loading/actions'
import getters from './Loading/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
